import { ModelData } from "../types/models";

export const TIGUAN : ModelData = {
  model: 'tiguan',
  modelName: 'Tiguan',
  code: 'VW0701_VW0701',
  priority: 1
};

export const TAOS : ModelData = {
  model: 'taos',
  modelName: 'Taos',
  code: 'VW2020_VW2020',
  priority: 2
};

export const ATLAS : ModelData = {
  model: 'atlas',
  modelName: 'Atlas',
  code: 'VW1701_VW1701',
  priority: 3
};

export const ID4 : ModelData = {
  model: 'id.4',
  modelName: 'ID.4',
  code: 'VW1901_VW1901',
  priority: 4
};

export const ATLASCROSSPORT : ModelData = { 
  model: 'acs',
  modelName: 'Atlas Cross Sport',
  code: 'VW1702_VW1702',
  priority: 5
};